/**
 * Compares a pathname against a route, ignoring trailing slashes.
 *
 * Shared because getting it wrong fails silently and this app makes it easy to get wrong:
 * `trailingSlash: true` means a rendered pathname is `/sso-silent/`, not `/sso-silent`, so an
 * exact `===` misidentifies the very page it is looking for — and both callers use the answer
 * to decide whether to strip the site chrome, which is not a decision that announces a
 * mistake. One place to state the rule, and one place to fix it.
 */
export function pathEquals(pathname: string | null | undefined, route: string): boolean {
   return (pathname ?? "").replace(/\/+$/, "") === route
}
